import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface SessionStep {
  id: string;
  question_text: string;
  user_answer: string | null;
  answer_summary: string | null;
  step_number: number;
  phase: number;
  subphase: string;
  clarity_score: number | null;
  created_at: string;
}

export const useSessionSteps = (sessionId: string | undefined) => {
  const [steps, setSteps] = useState<SessionStep[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!sessionId) {
      setIsLoading(false);
      return;
    }

    const fetchSteps = async () => {
      setIsLoading(true);
      const { data, error } = await supabase
        .from("decision_steps")
        .select("*")
        .eq("session_id", sessionId)
        .order("step_number", { ascending: true });

      if (error) {
        console.error("Error fetching session steps:", error);
      } else {
        setSteps(data || []);
      }
      setIsLoading(false);
    };

    fetchSteps();

    // Subscribe to new steps
    const channel = supabase
      .channel(`session_steps_${sessionId}`)
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "decision_steps",
          filter: `session_id=eq.${sessionId}`,
        },
        (payload) => {
          setSteps((prev) => [...prev, payload.new as SessionStep]);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [sessionId]);

  return { steps, isLoading };
};
